import _regeneratorRuntime from '@babel/runtime/helpers/esm/regeneratorRuntime';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';

function termsOfService(aemAxiosIntance) {
  function getAllTermsOfServiceByCountry(_x) {
    return _getAllTermsOfServiceByCountry.apply(this, arguments);
  }
  function _getAllTermsOfServiceByCountry() {
    _getAllTermsOfServiceByCountry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(country) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return aemAxiosIntance.get("/terms-policy?country=".concat(country, "&richText=true"));
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getAllTermsOfServiceByCountry.apply(this, arguments);
  }
  return {
    getAllTermsOfServiceByCountry: getAllTermsOfServiceByCountry
  };
}

export { termsOfService as default };
//# sourceMappingURL=termsOfService.js.map
